import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHog } from 'posthog-js';

declare global {
  interface Window {
    posthog?: PostHog;
  }
}

/**
 * Hook to expose PostHog instance to window.posthog for toolbar functionality
 * Uses the PostHog instance from PostHogProvider context
 */
export const usePostHogWindow = (): void => {
  const posthog = usePostHog();

  useEffect(() => {
    // Only proceed if we're in a browser environment and PostHog is available
    if (typeof window !== 'undefined' && posthog) {
      // Expose PostHog to window for toolbar functionality
      window.posthog = posthog;
    }

    // Cleanup function to remove window.posthog when component unmounts
    return () => {
      if (typeof window !== 'undefined' && window.posthog) {
        delete window.posthog;
      }
    };
  }, [posthog]);
};
